module.exports = __webpack_public_path__ + "img/11.486dc571.png";